export default __webpack_public_path__ + "static/media/photo_2023-08-11_17-41-31-removebg-preview.a75d553d.png";